import { ImageStack, DocumentEditSimple, ImageAdd } from '@creditornot/cb-icons';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useRouteMatch } from 'react-router';
import styled from 'styled-components';

import { ImageGalleryNavigationItem } from './ImageGalleryNavigationItem';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ImageGalleryNavigation = () => {
  const { url } = useRouteMatch();

  return (
    <Root>
      <ImageGalleryNavigationItem
        label={<FormattedMessage id="shared-menu.editor.image-gallery.menu.browse-images" />}
        href={`${url}`}
        icon={<ImageStack width={18} height={18} />}
        exact
      />
      <ImageGalleryNavigationItem
        label={<FormattedMessage id="shared-menu.editor.image-gallery.menu.edit-images" />}
        href={`${url}/edit-images`}
        icon={<DocumentEditSimple width={18} height={18} />}
        exact
      />
      <ImageGalleryNavigationItem
        label={<FormattedMessage id="shared-menu.editor.image-gallery.menu.add-to-items" />}
        href={`${url}/add-to-items`}
        icon={<ImageAdd width={24} height={24} />}
        exact
      />
    </Root>
  );
};
